export default __webpack_public_path__ + "static/media/01KV33R6H9BBYCR6RZPB9XRQY9.2761cf7e.webp";